import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { transactionGOSSetFields } from '../../constants/transactionGOS';

class TransactionGOSSetInformation extends React.Component {
  static propTypes = {
    info: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { t, info, transactionType } = this.props;

    const isTransfer =
      transactionType === 'INCOMING' || transactionType === 'OUTGOING';
    const gosSetIndex = info[transactionGOSSetFields.GOS_SET_INDEX];

    return (
      <React.Fragment>
        <Row className="global-margin-bottom-10">
          <Col span={24}>
            <b>{t('gosSetInfo.title', { gosSetIndex })}: </b>
          </Col>
          <Col span={24}>
            {t('gosSetInfo.startGosId')}:{' '}
            {info[transactionGOSSetFields.GOS_SET_START_ID]}
          </Col>
          <Col span={24}>
            {t('gosSetInfo.endGosId')}:{' '}
            {info[transactionGOSSetFields.GOS_SET_END_ID]}
          </Col>
          <Col span={24}>
            {t('gosSetInfo.gosQuantityMj')}:{' '}
            {info[transactionGOSSetFields.GOS_VALUE_MJ_IN_SET]}
          </Col>
          <Col span={24}>
            {t('gosSetInfo.gosNaturalQuantityMj')}:{' '}
            {info[transactionGOSSetFields.GOS_NATURAL_VALUE_MJ_IN_SET]}
          </Col>
          {isTransfer && (
            <Col span={24}>
              {t('gosSetInfo.cost')}: {info[transactionGOSSetFields.GOS_COST]}
            </Col>
          )}
          {transactionType === 'LOCKING' && (
            <Col span={24}>
              {t('gosSetInfo.lockingPeriod')}:{' '}
              {info[transactionGOSSetFields.GOS_LOCKING_PERIOD_START]}
              {' - '}
              {info[transactionGOSSetFields.GOS_LOCKING_PERIOD_END]}
            </Col>
          )}
          <Col span={24}>
            {t('gosSetInfo.issuingPeriod')}:{' '}
            {info[transactionGOSSetFields.GOS_ISSUING_PERIOD]}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default TransactionGOSSetInformation;
